import ajax from '../utils/ajax';

export const healthProfileData = {
  get: id => ajax.get(`/api/health-profile/${id}/`),
  post: payload => ajax.post('/api/health-profile/', payload),
  put: (id, payload) => ajax.put(`/api/health-profile/${id}/`, payload)
};
